/*
  GOOD Hydration – Animation beim Erreichen des Gratisversands
  Zeigt einen kurzen Konfetti-Effekt, sobald der Warenkorb die Gratisversand-Grenze
  ueberschreitet. Laeuft nur beim Wechsel von "nicht erreicht" zu "erreicht",
  nicht bei jedem Oeffnen des Warenkorbs.
*/
(function () {
  if (window.customElements.get('free-shipping-celebration')) return;

  var STORAGE_KEY = 'gh_free_shipping_reached';
  var COLORS = ['#1f9d55', '#ffc83d', '#1e316a', '#e02b27', '#00badb', '#ff7ab6'];

  function readState() {
    try { return window.sessionStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  function writeState(value) {
    try { window.sessionStorage.setItem(STORAGE_KEY, value); } catch (e) { /* Speicher nicht verfuegbar */ }
  }

  function isVisible(element) {
    var drawer = element.closest('cart-drawer');
    if (drawer && !drawer.hasAttribute('open')) return false;
    return element.getClientRects().length > 0;
  }

  class FreeShippingCelebration extends HTMLElement {
    connectedCallback() {
      var self = this;
      // Kurz warten, bis der Warenkorb nach dem Hinzufuegen geoeffnet ist
      window.setTimeout(function () { self._check(); }, 350);
    }

    _check() {
      var bar = this.closest('free-shipping-bar');
      if (!bar) return;

      var reached = bar.classList.contains('free-shipping-bar--reached');
      var previous = readState();
      var visible = isVisible(this);

      if (reached && previous !== '1' && visible) {
        this._celebrate(bar);
      }

      // Den Zustand nur speichern, wenn der Kunde ihn auch gesehen hat
      if (visible || !reached) {
        writeState(reached ? '1' : '0');
      }
    }

    _celebrate(bar) {
      bar.classList.add('free-shipping-bar--celebrate');
      window.setTimeout(function () { bar.classList.remove('free-shipping-bar--celebrate'); }, 1600);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var count = 28;
      for (var i = 0; i < count; i++) {
        var piece = document.createElement('i');
        var angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.6;
        var distance = 60 + Math.random() * 70;
        piece.style.setProperty('--x', Math.round(Math.cos(angle) * distance * 1.6) + 'px');
        piece.style.setProperty('--y', Math.round(Math.sin(angle) * distance - 30) + 'px');
        piece.style.setProperty('--r', Math.round(Math.random() * 720 - 360) + 'deg');
        piece.style.setProperty('--d', Math.round(Math.random() * 120) + 'ms');
        piece.style.background = COLORS[i % COLORS.length];
        if (i % 3 === 0) piece.style.borderRadius = '50%';
        this.appendChild(piece);
      }

      var self = this;
      window.setTimeout(function () { self.replaceChildren(); }, 1500);
    }
  }

  window.customElements.define('free-shipping-celebration', FreeShippingCelebration);
})();
